module.exports = __webpack_public_path__ + "static/img/06.0b4cbe9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/06.jpg
// module id = 0Zgq
// module chunks = 0